import angular from 'angular';
import itemSaleLimiterDialogTemplate from './ItemSaleLimiterDialog.template.html';

/*******************************************************************************
 * ItemSaleLimiterDialogService */
/**
 * Service: ItemSaleLimiterDialog
 *
 * Utility to show a dialog to manage Item Limiters.
 *******************************************************************************/
/* @ngInject */ export function ItemSaleLimiterDialogService(
  $q,
  $uibModal,
  BooksSvc,
  BusyScreen
) {
  /** Dialog Controller */
  var ItemSaleLimiterDialogController = function (
    $scope,
    Alert,
    endDate,
    limiter,
    org,
    restrictLimiters,
    startDate,
    statuses,
    tags,
    uiGridConstants
  ) {
    /*--------------------------------------------------*/
    /* Flag to ensure that the first time the           */
    /* timeSpecific flag is set while loading the       */
    /* limiters, the watch ignores the change in value. */
    /*--------------------------------------------------*/
    var initialLoad = true;

    /*------------------*/
    /* Scope properties */
    /*------------------*/
    /** Data Object              */ $scope.data = {};
    /** Current limiter          */ $scope.limiter = limiter;
    /** Time specific checkbox   */ $scope.timeSpecific =
      !isNaN(Date.parse(startDate)) || !isNaN(Date.parse(endDate));
    /** Start date               */ $scope.data.startDate = startDate;
    /** End date                 */ $scope.data.endDate = endDate;
    /** Selected grades          */ $scope.selectedGrades =
      typeof limiter.grade == 'string' ? limiter.grade.split(',') : [];
    /** Show only grade/quantity */ $scope.restrictLimiters = restrictLimiters;
    /** Validator Object         */ $scope.validators = {};

    /** Constant list of grades */
    $scope.gradeList = [
      { id: 0, label: '1' },
      { id: 1, label: '2' },
      { id: 2, label: '3' },
      { id: 3, label: '4' },
      { id: 4, label: '5' },
      { id: 5, label: '6' },
      { id: 6, label: '7' },
      { id: 7, label: '8' },
      { id: 8, label: '9' },
      { id: 9, label: '10' },
      { id: 10, label: '11' },
      { id: 11, label: '12' },
      { id: 12, label: '13' },
      { id: 13, label: '14' },
      { id: 14, label: '15' }
    ];

    /** Status Grid */
    $scope.dgStatuses = {
      enableColumnMenus: false,
      enableFiltering: false,
      enableFullRowSelection: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      enableSelectAll: false,
      minRowsToShow: 5,
      maxRowsToShow: 5,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
      enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      onRegisterApi: function (gridApi) {
        $scope.dgStatuses.api = gridApi;
      },
      data: [],
      columnDefs: [
        {
          field: 'description',
          displayName: 'Status'
        },
        {
          field: 'restricted',
          maxWidth: 95,
          displayName: 'Restricted',
          type: 'boolean',
          cellTemplate:
            '<input type="checkbox" ng-change="grid.appScope.updateStatus(row.entity, col);" ng-model="row.entity.restricted">'
        },
        {
          field: 'required',
          maxWidth: 95,
          displayName: 'Required',
          type: 'boolean',
          cellTemplate:
            '<input type="checkbox" ng-change="grid.appScope.updateStatus(row.entity, col);" ng-model="row.entity.required">'
        }
      ]
    };

    /***************************************************************************
     * datesValid */
    /**
     * Checks if the start and end dates are valid.
     *
     * @return  String  Error msg if dates fail validation, null=date valid
     ***************************************************************************/
    function datesValid() {
      if ($scope.data.startDate == null && $scope.data.endDate == null)
        return 'At least one of the Time Specific dates must be set.';

      if ($scope.data.startDate > $scope.data.endDate)
        return 'Start date must be before End date.';

      return null;
    }

    /*************************************************************************
     * finish */
    /**
     * Finish button handler. If data is valid, resolve and close the modal
     * dialog.
     *************************************************************************/
    $scope.finish = function () {
      /*-----------------------------------------------*/
      /* At least one entry is not a valid date, exit. */
      /*-----------------------------------------------*/
      if (!$scope.validators.validate()) return;

      /*--------------------------------------------------*/
      /* Validate dates if the time specific flag is set. */
      /*--------------------------------------------------*/
      if ($scope.timeSpecific) {
        var errorMsg = datesValid();
        if (errorMsg) {
          Alert.error(errorMsg, 'Date Error');
          return;
        }
      }

      /*-------------------------*/
      /* Get the list of grades. */
      /*-------------------------*/
      $scope.limiter.grade = $scope.selectedGrades.join(',');

      /*------------------------------------------------*/
      /* Make the dates available on the dialog object. */
      /*------------------------------------------------*/
      var limiterDates = {
        startDate: $scope.timeSpecific ? $scope.data.startDate : null,
        endDate: $scope.timeSpecific ? $scope.data.endDate : null
      };

      /*-----------------------------------------------------------*/
      /* Close dialog and return the limiters, dates and statuses. */
      /*-----------------------------------------------------------*/
      $scope.$close({
        limiter: $scope.limiter,
        dates: limiterDates,
        statuses: statuses
      });
    };

    /*************************************************************************
     * init */
    /**
     * Initialize the modal dialog.
     *************************************************************************/
    function init() {
      /*----------------------------------------------------*/
      /* Populate the grid with the list of available tags. */
      /*----------------------------------------------------*/
      $scope.dgStatuses.data = tags;

      /*---------------------------------------*/
      /* Update the list of tags and statuses. */
      /*---------------------------------------*/
      updateList();
    }

    /***************************************************************************
     * updateList */
    /**
     * Updates the list of tags for the actual values.
     ***************************************************************************/
    function updateList() {
      /*---------------------------------------------------*/
      /* Start the loop. Ensure that we clear any previous */
      /* flag. If a match is found, we will set the        */
      /* appropriate flags and continue to the next one.   */
      /*---------------------------------------------------*/
      angular.forEach(tags, function (tag) {
        tag.restricted = false;
        tag.required = false;

        for (var i = 0; i < statuses.length; i++)
          if (tag.id == statuses[i].id) {
            tag.restricted = statuses[i].restricted;
            tag.required = statuses[i].required;
            break;
          }
      });
    }

    /***************************************************************************
     * updateStatus */
    /**
     * Click event handler for the restricted/required checkboxes in the grid.
     *
     * A status can have either the restricted or the required flag set, or neither
     * flag set. Both flags cannot be set to true.
     *
     * @param  row  Status from the grid.
     * @param  col  Current ui-grid column
     ***************************************************************************/
    $scope.updateStatus = function (row, col) {
      /*---------------------------------------------------*/
      /* Cache the new value of the field that was changed. */
      /*---------------------------------------------------*/
      var newVal = row[col.field];

      /*-----------------------*/
      /* Clear all checkboxes. */
      /*-----------------------*/
      row.restricted = false;
      row.required = false;

      /*-----------------------------------------------*/
      /* Set the value for the field that was changed. */
      /*-----------------------------------------------*/
      row[col.field] = newVal;

      /*------------------------------*/
      /* Update the list of statuses. */
      /*------------------------------*/
      statuses.length = 0;
      angular.forEach($scope.dgStatuses.data, function (status) {
        if (status.restricted || status.required) statuses.push(status);
      });
    };

    /*---------------------------------------*/
    /* When the time specific checkbox is    */
    /* clicked, set the start and end dates. */
    /*---------------------------------------*/
    $scope.$watch('timeSpecific', function (value) {
      if (initialLoad) {
        initialLoad = false;
        return;
      }

      /*--------------------*/
      /* Clear dates first. */
      /*--------------------*/
      $scope.data.startDate = $scope.data.endDate = null;

      if (value) {
        var dat = new Date();
        var startDate = new Date(
          org.fyMonth > dat.getMonth()
            ? dat.getFullYear() - 1
            : dat.getFullYear(),
          org.fyMonth - 1,
          org.fyDay
        );

        $scope.data.startDate = startDate;
        $scope.data.endDate = new Date(
          startDate.getFullYear() + 1,
          startDate.getMonth(),
          startDate.getDate(),
          startDate.getHours(),
          startDate.getMinutes(),
          startDate.getSeconds(),
          startDate.getMilliseconds() - 1
        );
      }
    });

    /*----------------*/
    /* Set up dialog. */
    /*----------------*/
    init();
  };

  /*************************************************************************
   * show */
  /**
   * Show the modal dialog for reviewing and managing sales limiters.
   *
   * @param   limiter     Limiter object to be managed. Null=New
   * @param   statuses    Current tag selections to display.
   * @param   tags        List of available tags.
   * @param   startDate   Sale start date.
   * @param   endDate     Sale end date.
   *
   * @return  Promise     Resolves with an object containing the new/updated
   *                      limiter a date object with start and end dates and
   *                      the new list of statuses.
   *************************************************************************/
  this.show = function (limiter, statuses, tags, startDate, endDate) {
    BusyScreen.setBusy(true);

    /*---------------------------------------------------*/
    /* Get the org info for the fiscal year start and    */
    /* end dates and check if the limiters dialog should */
    /* be restricted to just grade and quantity inputs.  */
    /*---------------------------------------------------*/
    return $q
      .all([
        BooksSvc.getOrganization().then(),
        BooksSvc.getWebConstants('restrictLimiters').then()
      ])
      .then(function (resp) {
        /*-------------------------------*/
        /* Empty default limiter object. */
        /*-------------------------------*/
        var newLimiter = { balance: 0, grade: '', quantity: 0 };

        BusyScreen.setBusy(false);
        return $uibModal.open({
          template: itemSaleLimiterDialogTemplate,
          size: 'md',
          backdrop: 'static',
          controller: ItemSaleLimiterDialogController,
          resolve: {
            limiter: function () {
              return limiter ? angular.copy(limiter) : newLimiter;
            },
            tags: function () {
              return tags ? angular.copy(tags) : [];
            },
            statuses: function () {
              return statuses ? angular.copy(statuses) : [];
            },
            startDate: function () {
              return startDate ? angular.copy(startDate) : null;
            },
            endDate: function () {
              return endDate ? angular.copy(endDate) : null;
            },
            org: function () {
              return resp[0].data;
            },
            restrictLimiters: function () {
              return resp[1].data;
            }
          }
        }).result;
      });
  };
}
